import { render, staticRenderFns } from "./TwoRow2.vue?vue&type=template&id=1b1cde6a"
import script from "./TwoRow2.vue?vue&type=script&lang=js"
export * from "./TwoRow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports